<template>
    <div id="taskRepository">
        <el-header class="task-header">

            <div class="header-left">
                <h1>任务库</h1>
                <el-popover class="choice" placement="bottom-start" width="288" trigger="click">
                    <div class="taskChoice">
                        <span class="title">请选择创建的任务类型</span>

                        <div class="choice">
                            <div @click="ptTaskDetail = true">
                                <img src="./normalTask.png" />
                                <span>普通任务</span>
                            </div>

                            <div @click="xhTaskDetail = true">
                                <img src="./circleTask.png" />
                                <span>循环任务</span>
                            </div>
                        </div>

                    </div>
                    <el-button slot="reference" icon="el-icon-circle-plus-outline" size="mini" circle></el-button>
                </el-popover>
            </div>

            <div class="header-right">
                <el-input v-model="searchName" @input="searchList" placeholder="搜索任务名称" size="small">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
            </div>

        </el-header>

        <!-- 任务列表 -->
        <el-row :gutter="8" class="task-list" v-loading="taskLoad">
            <div class="noData" v-if="total === 0">
                <p class="tip">暂无数据</p>
                <div>
                    <span>请点击</span>
                    <el-popover class="choice" placement="bottom-start" width="288" trigger="click">
                        <div class="taskChoice">
                            <span class="title">请选择创建的任务类型</span>

                            <div class="choice">
                                <div @click="ptTaskDetail = true">
                                    <img src="./normalTask.png" />
                                    <span>普通任务</span>
                                </div>

                                <div @click="xhTaskDetail = true">
                                    <img src="./circleTask.png" />
                                    <span>循环任务</span>
                                </div>
                            </div>

                        </div>
                        <el-button slot="reference" icon="el-icon-circle-plus-outline" size="mini" circle></el-button>
                    </el-popover>
                    <span>添加任务</span>
                </div>
            </div>

            <el-col :span="4" v-for="(item, index) in taskRepository" :key="index">
                <div class="task-item" @click="showEdit(item.tableId, item.tableType)">

                    <div class="task-list-name" :title="item.tableName">
                        <span class="sign" :class="{circleSign: item.tableType === 'C'}"></span>
                        <span>
                            <p>{{ item.tableName }}</p>
                            <p>{{ item.remark }}</p>
                        </span>
                    </div>

                    <el-popover placement="bottom" trigger="hover">
                        <el-button type="danger text" size="small" @click="delData(item.tableId, item.tableType)">删除</el-button>
                        <i class="iconfont icon_gengduo" slot="reference"></i>
                    </el-popover>

                </div>
            </el-col>
        </el-row>

        <el-footer>
            <div class="equipPaging">
                <el-pagination small background @current-change="currentChange" :pager-count="5" layout="prev, pager, next" :page-size="pageSize" :current-page="pageNo" :total="total">
                </el-pagination>
            </div>
        </el-footer>

        <!-- 普通任务框 -->
        <el-dialog width="960px" top="10vh" :close-on-click-modal="false" :visible.sync="ptTaskDetail" @closed="closePtDetail" center>

            <div slot="title">
                <p><span class="pt-task-logo"></span>新增普通任务</p>
            </div>

            <div class="dialog-body flex-start-body">

                <div class="dialog-body-pt-left dialog-body-item">
                    <el-header>任务信息</el-header>
                    <el-form ref="ptForm" :model="ptForm" :rules="ptRule" class="base-info">
                        <el-form-item label="任务名称" prop="tableName">
                            <el-input v-model="ptForm.tableName" placeholder="请输入" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="任务描述">
                            <el-input v-model="ptForm.comment" type="textarea" maxlength="30" placeholder="请输入任务内容描述.."></el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div class="dialog-body-pt-right">
                    <div class="task-sys-list dialog-body-item">

                        <el-header class="body-title">
                            系统控制项
                            <div>
                                <i class="el-icon-circle-plus-outline" @click="addPtTaskSys"></i>
                                <i class="iconfont iconshanchu" @click="deletePtTaskSys"></i>
                            </div>
                        </el-header>

                        <div class="task-table">
                            <el-table ref="taskSysTable" :data="ptForm.procTaskSys" style="width: 100%" :cell-style="cellStyle" @selection-change="sysSelectionChange">

                                <el-table-column type="selection" width="32"></el-table-column>

                                <el-table-column label="序号" width="1">
                                    <template slot-scope="scope">{{scope.row.index = scope.$index+1}}</template>
                                </el-table-column>

                                <el-table-column label="时间" width="104">
                                    <template slot-scope="scope">
                                        <el-time-picker v-model="scope.row.time" size="small" :clearable="false"></el-time-picker>
                                    </template>
                                </el-table-column>

                                <el-table-column label="控制项名称">
                                    <template slot-scope="scope">
                                        <el-select v-model="scope.row.procCode" placeholder="请选择" size="small">
                                            <el-option v-for="item in sysList" :key="item.procCode" :label="item.procName" :value="item.procCode"></el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>

                                <el-table-column label="有效时段" width="104">
                                    <template slot-scope="scope">
                                        <el-time-picker v-model="scope.row.timeDur" size="small" :clearable="false"></el-time-picker>
                                    </template>
                                </el-table-column>

                            </el-table>
                        </div>
                    </div>

                    <div class="task-eqp-list dialog-body-item">

                        <el-header class="body-title">
                            设备控制项
                            <div>
                                <i class="el-icon-circle-plus-outline" @click="addPtTaskEqp"></i>
                                <i class="iconfont iconshanchu" @click="deletePtTaskEqp"></i>
                            </div>
                        </el-header>

                        <div class="task-table">
                            <el-table ref="taskEqpTable" :data="ptForm.procTaskEqp" style="width: 100%" :cell-style="cellStyle" @selection-change="eqpSelectionChange">

                                <el-table-column type="selection" width="32"></el-table-column>

                                <el-table-column label="序号" width="1">
                                    <template slot-scope="scope">{{scope.row.index = scope.$index+1}}</template>
                                </el-table-column>

                                <el-table-column label="时间" width="104">
                                    <template slot-scope="scope">
                                        <el-time-picker v-model="scope.row.time" size="small" :clearable="false"></el-time-picker>
                                    </template>
                                </el-table-column>

                                <el-table-column label="控制项名称">
                                    <template slot-scope="scope">
                                        <el-cascader v-model="scope.row.equipSetValue" :ref="scope.$index+1" @change="changePtCascader(scope.$index+1)" :options="eqpList" size="small" :props="casProp"></el-cascader>
                                    </template>
                                </el-table-column>

                                <el-table-column label="设置值" width="104">
                                    <template slot-scope="scope">
                                        <el-input-number v-model="scope.row.value" size="small" :disabled="cascaderPtArr[scope.$index]"></el-input-number>
                                    </template>
                                </el-table-column>

                                <el-table-column label="有效时段" width="104">
                                    <template slot-scope="scope">
                                        <el-time-picker v-model="scope.row.timeDur" size="small" :clearable="false"></el-time-picker>
                                    </template>
                                </el-table-column>

                            </el-table>
                        </div>
                    </div>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="ptTaskDetail = false" size="small">取 消</el-button>
                <el-button type="primary" @click="savePtTask" size="small">确 定</el-button>
            </div>

        </el-dialog>

        <!-- 循环任务框 -->
        <el-dialog width="1200px" top="10vh" :visible.sync="xhTaskDetail" @closed="closeXhDetail" :close-on-click-modal="false" center>

            <div slot="title">
                <p><span class="xh-task-logo"></span>新增循环任务</p>
            </div>

            <div class="dialog-body">

                <div class="dialog-body-xh-left">
                    <div class="dialog-body-item">
                        <el-header>任务信息</el-header>
                        <el-form ref="xhForm" :model="xhForm" :rules="xhRule" class="base-info">

                            <el-form-item label="任务名称" prop="tableName">
                                <el-input v-model="xhForm.tableName" placeholder="请输入" size="small"></el-input>
                            </el-form-item>

                            <el-form-item label="任务描述">
                                <el-input v-model="xhForm.comment" type="textarea" maxlength="30" placeholder="请输入任务内容描述.."></el-input>
                            </el-form-item>

                            <el-form-item label="执行时间" prop="cycleTask.intervalTime">
                                <el-time-picker is-range v-model="xhForm.cycleTask.intervalTime" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围" size="small" :clearable="false">
                                </el-time-picker>
                            </el-form-item>

                        </el-form>
                    </div>

                    <div class="dialog-body-item">

                        <el-collapse v-model="activeNames">
                            <el-collapse-item title="附加设置" name="1">
                                <el-form :model="xhForm" :rules="xhForm" class="base-info" label-position=top>

                                    <el-form-item label="执行方式">
                                        <el-radio-group v-model="xhForm.cycleTask.implement" size="small">
                                            <el-radio label="1" border>立即开始执行</el-radio>
                                            <el-radio label="2" border>整点开始执行</el-radio>
                                            <el-radio label="3" border>指定开始时间
                                                <el-time-picker v-model="xhForm.cycleTask.zhidingTime" size="small" :clearable="false"></el-time-picker>
                                            </el-radio>
                                        </el-radio-group>
                                    </el-form-item>

                                    <el-form-item label="限制最大循环次数">
                                        <el-checkbox v-model="xhForm.cycleTask.isMaxCycle" border size="small">限制最大执行次数
                                            <el-input-number v-model="xhForm.cycleTask.maxCycleNum" :disabled="!xhForm.cycleTask.isMaxCycle" size="small"></el-input-number>
                                        </el-checkbox>
                                        <el-checkbox v-model="xhForm.cycleTask.cycleMustFinish" label="执行完整循环" border size="small"></el-checkbox>
                                    </el-form-item>

                                </el-form>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </div>

                <div class="dialog-body-xh-center dialog-body-item">
                    <el-header>任务控制项</el-header>
                    <div class="base-info">
                        <draggable tag="div" v-bind="dragOptions" v-model="xhForm.cycleTaskContent" class="ctr-list">
                            <transition-group type="transition">
                                <div class="ctr-item dialog-body-item" v-for="(item, index) in xhForm.cycleTaskContent" :key="index">
                                    <i class="iconfont icontuozhuai"></i>
                                    <p v-if="item.type === 'S'">系统控制：{{item.cmdNm}}</p>
                                    <p v-if="item.type === 'E'">设备控制：{{item.equipSetNm}}</p>
                                    <p v-if="item.type === 'T'">时间间隔：{{getTime(item.sleepTime)}}</p>
                                </div>
                            </transition-group>
                        </draggable>
                        <draggable :options="{draggable: '.item'}" tag="div" v-bind="dragOptions" class="del-ctr-list">
                            <div>
                                <i class="iconfont iconshanchu"></i>
                                拖动到此处删除
                            </div>
                        </draggable>
                    </div>
                </div>

                <div class="dialog-body-xh-right">
                    <div class="dialog-body-item">
                        <el-header class="body-title">
                            系统控制项
                            <el-button size="small" icon="el-icon-circle-plus-outline" @click="addSysItem">添加</el-button>
                        </el-header>
                        <div class="base-info">
                            <el-form :model="xhSysForm" label-position=top>
                                <el-form-item label="选择控制项" prop="tableName">
                                    <el-select v-model="xhSysForm.control" placeholder="请选择" size="small">
                                        <el-option v-for="item in sysList" :key="item.procCode" :label="item.procName" :value="item.procCode"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>

                    <div class="dialog-body-item">
                        <el-header class="body-title">
                            设备控制项
                            <el-button size="small" icon="el-icon-circle-plus-outline" @click="addEqpItem">添加</el-button>
                        </el-header>
                        <div class="base-info">
                            <el-form :model="xhEqpForm" label-position=top>
                                <el-form-item label="选择控制项" prop="tableName">
                                    <el-cascader v-model="xhEqpForm.control" ref="xhCascader" @change="changeXhCascader" :options="eqpList" size="small" :props="casProp"></el-cascader>
                                </el-form-item>
                                <el-form-item label="设置值" prop="tableName">
                                    <el-input-number v-model="xhEqpForm.value" size="small" :disabled="cascaderXh"></el-input-number>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>

                    <div class="dialog-body-item">
                        <el-header class="body-title">
                            时间间隔
                            <el-button size="small" icon="el-icon-circle-plus-outline" @click="addTimeItem">添加</el-button>
                        </el-header>

                        <div class="base-info">
                            <el-form :model="xhTimeForm">
                                <el-row :gutter="8">

                                    <el-col :span="6">
                                        <el-form-item>
                                            <el-input-number v-model="xhTimeForm.day" size="small" placeholder="天"></el-input-number>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="6">
                                        <el-form-item>
                                            <el-input-number v-model="xhTimeForm.hour" size="small" placeholder="时"></el-input-number>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="6">
                                        <el-form-item>
                                            <el-input-number v-model="xhTimeForm.min" size="small" placeholder="分"></el-input-number>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="6">
                                        <el-form-item>
                                            <el-input-number v-model="xhTimeForm.second" size="small" placeholder="秒"></el-input-number>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                            </el-form>
                        </div>
                    </div>
                </div>

            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="xhTaskDetail = false" size="small">取 消</el-button>
                <el-button type="primary" @click="saveXhTask" size="small">确 定</el-button>
            </div>

        </el-dialog>
    </div>
</template>
<script>
import draggable from 'vuedraggable';
import myUtils from './myUtils'
export default {
    name: 'helloName',
    data () {
        return {
            searchName: '',
            taskLoad: false,

            // 任务库列表
            taskRepository: [],

            pageNo: 1,
            total: 0,
            pageSize: 48,

            // 用于判断是新增还是编辑
            isNewPtTask: true,
            isNewXhTask: true,

            ptTaskDetail: false,
            xhTaskDetail: false,

            // 控制项的下拉列表
            sysList: [],
            eqpList: [],

            casProp: {
                value: 'equipNo',
                label: 'equipNm',
                children: 'setInfos'
            },

            // 新增普通任务的表单
            ptForm: {
                tableId: '',
                tableName: '',
                comment: '',
                procTaskSys: [
                    {
                        time: new Date(1900, 1, 1, new Date().getHours(), new Date().getMinutes(), new Date().getSeconds()),
                        timeDur: new Date(1900, 1, 1, 0, 0, 5),
                        procCode: '',
                        cmdNm: ''
                    }
                ],
                procTaskEqp: []
            },
            ptRule: {
                tableName: [
                    {
                        type: 'string',
                        required: true,
                        message: '请输入任务名称'
                    }
                ]
            },

            // 表格选中项
            sysSelection: [],
            eqpSelection: [],

            // 循环任务表单
            xhForm: {
                tableId: '',
                tableName: '',
                comment: '',
                cycleTask: {                          // 循环任务表单信息
                    beginTime: '1900-01-01 00:00:00',        // 开始时间
                    endTime: '1900-01-01 00:00:00',          // 结束时间
                    intervalTime: [new Date(2020, 1, 1, 0, 0, 0), new Date(2020, 1, 1, 23, 59, 59)], // 开始时间与结束时间
                    zhenDianDo: '0',
                    zhidingDo: '0',
                    implement: '1',
                    cycleMustFinish: '0',                    // 是否执行完整循环
                    zhidingTime: new Date(2020, 1, 1, 0, 0, 0),      // 指定开始时间
                    isMaxCycle: false,                            // 最大循环次数
                    maxCycleNum: 0                           // 最大循环次数
                },
                cycleTaskContent: []
            },
            xhRule: {
                tableName: [
                    {
                        type: 'string',
                        required: true,
                        message: '请输入任务名称'
                    }
                ],
                cycleTask: {
                    intervalTime: [
                        {
                            type: 'array',
                            required: true,
                            message: '请输入执行时间'
                        }
                    ]
                }
            },

            activeNames: [],

            // 循环任务右侧新增项
            xhSysForm: {
                control: ''
            },
            xhEqpForm: {
                control: [],
                value: 0
            },
            xhTimeForm: {
                day: undefined,
                hour: undefined,
                min: undefined,
                second: undefined
            },

            // 用于储存表单设备控制值的diabled状态
            cascaderPtArr: [],
            cascaderXh: true
        }
    },
    components: {
        draggable
    },
    computed: {
        getTime () {
            return function (val) {
                let str = '';
                val = Number(val);
                str += Math.floor(val / (24 * 3600)) === 0 ? '' : Math.floor(val / (24 * 3600)) + 'd ';
                str += Math.floor((val % (24 * 3600)) / 3600) === 0 ? '' : Math.floor((val % (24 * 3600)) / 3600) + 'h ';
                str += Math.floor((val % (3600)) / 60) === 0 ? '' : Math.floor((val % (3600)) / 60) + 'm ';
                str += Math.floor(val % (60)) === 0 ? '' : Math.floor(val % (60)) + 's';
                return str;
            }
        },
        dragOptions () {
            return {
                animation: 0,
                group: 'description',
                disabled: false,
                ghostClass: 'originPosition',
                dragClass: 'moveGhost',
                chosenClass: 'originPosition'
            };
        }
    },
    mounted () {
        this.getRepository();
        this.evtSysControl();
        this.GetEquipSetParmTreeList();
    },
    methods: {

        // 获取任务库列表
        getRepository () {
            this.taskLoad = true;
            this.$api.tkGetRepository({
                pageSize: this.pageSize,
                pageNo: this.pageNo,
                searchName: this.searchName
            })
                .then((res) => {
                    let dat = res.data.data;
                    let code = res.data.code;
                    if (code !== 200) {
                        let msg = res.data.message;
                        this.$message({
                            type: 'error',
                            message: msg
                        });
                        return;
                    }
                    let list = JSON.parse(dat.list);
                    let target = '';
                    let obj = {};
                    this.total = dat.totalCount;
                    this.taskRepository = [];
                    for (let i = 0; i < list.length; i++) {
                        target = list[i];
                        obj = {};
                        obj.tableName = target.tableName;
                        obj.tableId = target.tableId;
                        obj.remark = target.remark === '' ? '-' : target.remark;
                        obj.tableType = target.tableType;
                        this.taskRepository.push(obj);
                    }
                    this.taskLoad = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.taskLoad = false;
                });
        },

        // 获取系统控制
        evtSysControl () {
            this.$api.evtSysControl().then((res) => {
                if (res.data.code === 200) {
                    this.sysList = res.data.data;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    });
                }
            }).catch(er => {
                this.$message({
                    type: 'error',
                    message: '获取系统控制失败'
                });
            });
        },

        // 获取设备控制
        GetEquipSetParmTreeList () {
            this.$api.GetEquipSetParmTreeList().then((res) => {
                if (res.data.code === 200) {
                    let str = JSON.stringify(res.data.data.rows).replace(/setNm/g, 'equipNm');
                    str = str.replace(/setNo/g, 'equipNo');

                    this.eqpList = JSON.parse(str);
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    });
                }
            }).catch(er => {
                this.$message({
                    type: 'error',
                    message: '获取设备控制失败'
                });
            });
        },

        searchList: myUtils.debounce(function (item) {
            this.getRepository();
        }, 500),

        currentChange (val) {
            this.pageNo = val;
            this.getRepository();
        },

        // 表格样式
        cellStyle ({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 1) { // 指定坐标
                return 'color: transparent !important'
            }
        },

        // 普通任务系统控制列表选中事件
        sysSelectionChange (val) {
            this.sysSelection = val;
        },

        // 普通任务设备控制列表选中事件
        eqpSelectionChange (val) {
            this.eqpSelection = val;
        },

        // 普通任务增加系统控制项
        addPtTaskSys () {
            this.ptForm.procTaskSys.push({
                time: new Date(1900, 1, 1, new Date().getHours(), new Date().getMinutes(), new Date().getSeconds()),
                timeDur: new Date(1900, 1, 1, 0, 0, 5),
                procCode: '',
                cmdNm: ''
            });
        },

        // 普通任务删除系统控制项
        deletePtTaskSys () {
            if (this.sysSelection.length === 0) {
                this.$message({
                    type: 'warning',
                    message: '请选择要移除的系统控制项'
                });
                return;
            }
            for (let i in this.sysSelection) {
                for (let j in this.ptForm.procTaskSys) {
                    if (this.sysSelection[i].index === this.ptForm.procTaskSys[j].index) {
                        this.ptForm.procTaskSys.splice(j, 1);
                    }
                }
            }
        },

        // 普通任务增加设备控制项
        addPtTaskEqp () {
            this.ptForm.procTaskEqp.push({
                time: new Date(1900, 1, 1, new Date().getHours(), new Date().getMinutes(), new Date().getSeconds()),
                timeDur: new Date(1900, 1, 1, 0, 0, 5),
                value: '',
                equipSetNm: '',
                equipSetValue: []
            });
            this.$set(this.cascaderPtArr, this.ptForm.procTaskEqp.length - 1, true);
        },

        // 普通任务删除设备控制项
        deletePtTaskEqp () {
            if (this.eqpSelection.length === 0) {
                this.$message({
                    type: 'warning',
                    message: '请选择要移除的设备控制项'
                });
                return;
            }
            for (let i in this.eqpSelection) {
                for (let j in this.ptForm.procTaskEqp) {
                    if (this.eqpSelection[i].index === this.ptForm.procTaskEqp[j].index) {
                        this.ptForm.procTaskEqp.splice(j, 1);
                    }
                }
            }
        },

        // 增加循环任务系统控制项
        addSysItem () {
            if (this.xhSysForm.control === '') {
                this.$message({
                    type: 'warning',
                    message: '请先选择系统控制项'
                });
                return;
            }
            this.xhForm.cycleTaskContent.push({
                type: 'S',
                procCode: this.xhSysForm.control,
                cmdNm: this.getCmdNm(this.xhSysForm.control)
            });
            this.xhSysForm.control = '';
        },

        // 增加循环任务设备控制项
        addEqpItem () {
            if (this.xhEqpForm.control.length === 0) {
                this.$message({
                    type: 'warning',
                    message: '请先选择设备控制项'
                });
                return;
            }
            this.xhForm.cycleTaskContent.push({
                type: 'E',
                equipNo: this.xhEqpForm.control[0],
                setNo: this.xhEqpForm.control[1],
                value: String(this.xhEqpForm.value),
                equipSetNm: `${this.$refs['xhCascader'].getCheckedNodes()[0].parent.label}-${this.$refs['xhCascader'].getCheckedNodes()[0].label}`
            });
            this.xhEqpForm = {
                control: [],
                value: 0
            }
            this.cascaderXh = true;
        },

        // 选择遥信时disabled为true
        changePtCascader (ref) {
            let boo = this.$refs[ref].getCheckedNodes()[0].data.setType !== 'V';
            this.$set(this.cascaderPtArr, ref - 1, boo);
            this.ptForm.procTaskEqp[ref - 1].value = boo ? 0 : this.ptForm.procTaskEqp[ref - 1].value;
        },

        changeXhCascader () {
            let boo = this.$refs['xhCascader'].getCheckedNodes()[0].data.setType !== 'V';
            this.cascaderXh = boo;
            this.xhEqpForm.value = boo ? 0 : this.xhEqpForm.value;
        },

        isUndefined (val) {
            let num = (typeof val) === 'undefined' ? 0 : Number(val);
            return num;
        },

        // 增加循环任务时间间隔
        addTimeItem () {
            let totalSeconds = this.isUndefined(this.xhTimeForm.day) * 24 * 60 * 60 + this.isUndefined(this.xhTimeForm.hour) * 60 * 60 + this.isUndefined(this.xhTimeForm.min) * 60 + this.isUndefined(this.xhTimeForm.second);
            if (totalSeconds === 0) {
                this.$message({
                    type: 'warning',
                    message: '请先输入时间间隔'
                });
                return;
            }
            this.xhForm.cycleTaskContent.push({
                type: 'T',
                sleepTime: totalSeconds,
                sleepUnit: 'S'
            });
            this.xhTimeForm = {
                day: undefined,
                hour: undefined,
                min: undefined,
                second: undefined
            }
        },

        // 根据系统控制编号获取名称
        getCmdNm (val) {
            let cmdNm = '';
            for (let item of this.sysList) {
                if (item.procCode === val) {
                    cmdNm = item.procName;
                }
            }
            return cmdNm;
        },

        // 编辑任务
        showEdit (val, type) {

            // 普通任务
            if (type === 'T') {
                this.$api.GetCommonTaskData({
                    tableId: val
                }).then((res) => {
                    if (res.data.code === 200) {
                        let data = res.data.data;

                        // 整理返回的数据赋值给表单
                        this.ptForm.tableId = data.tableId;
                        this.ptForm.tableName = data.tableName;
                        this.ptForm.comment = data.comment;
                        this.ptForm.procTaskSys = [];
                        this.ptForm.procTaskEqp = [];

                        // 系统控制项
                        for (let item of data.procTaskSys) {
                            let timeDate = new Date(item.time);
                            let timeDurDate = new Date(item.timeDur);
                            this.ptForm.procTaskSys.push({
                                time: new Date(1900, 1, 1, timeDate.getHours(), timeDate.getMinutes(), timeDate.getSeconds()),
                                timeDur: new Date(1900, 1, 1, timeDurDate.getHours(), timeDurDate.getMinutes(), timeDurDate.getSeconds()),
                                procCode: item.procCode,
                                cmdNm: item.cmdNm
                            })
                        }

                        // 设备控制项
                        for (let i = 0; i < data.procTaskEqp.length; i++) {
                            this.$set(this.cascaderPtArr, i, true)
                            let item = data.procTaskEqp[i];
                            let timeDate = new Date(item.time);
                            let timeDurDate = new Date(item.timeDur);
                            this.ptForm.procTaskEqp.push({
                                time: new Date(1900, 1, 1, timeDate.getHours(), timeDate.getMinutes(), timeDate.getSeconds()),
                                timeDur: new Date(1900, 1, 1, timeDurDate.getHours(), timeDurDate.getMinutes(), timeDurDate.getSeconds()),
                                equipSetNm: item.equipSetNm,
                                equipSetValue: [item.equipNo, item.setNo],
                                value: String(item.value)
                            })
                        }

                        this.ptTaskDetail = true;
                        this.isNewPtTask = false;
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.message
                        });
                    }
                }).catch((err) => {
                    console.log(err);
                    this.$message({
                        type: 'error',
                        message: '获取普通任务信息失败'
                    });
                });

                // 循环任务
            } else {
                this.$api.GetCycleTaskData({
                    tableId: val
                }).then((res) => {
                    if (res.data.code === 200) {
                        let data = res.data.data;

                        this.xhForm.tableId = data.tableId;
                        this.xhForm.tableName = data.tableName;
                        this.xhForm.comment = data.comment;
                        this.xhForm.cycleTaskContent = data.cycleTaskContent;

                        let dateBegin = new Date(data.cycleTask.beginTime);
                        let dateEnd = new Date(data.cycleTask.endTime);
                        this.xhForm.cycleTask.intervalTime = [
                            new Date(1900, 1, 1, dateBegin.getHours(), dateBegin.getMinutes(), dateBegin.getSeconds()),
                            new Date(1900, 1, 1, dateEnd.getHours(), dateEnd.getMinutes(), dateEnd.getSeconds())
                        ]
                        if (data.cycleTask.zhenDianDo === '1') {
                            this.xhForm.cycleTask.implement = '2';
                        } else if (data.cycleTask.zhidingDo === '1') {
                            this.xhForm.cycleTask.implement = '3';
                        } else {
                            this.xhForm.cycleTask.implement = '1';
                        }
                        let dateZhiding = new Date(data.cycleTask.zhidingTime)
                        this.xhForm.cycleTask.zhidingTime = new Date(1900, 1, 1, dateZhiding.getHours(), dateZhiding.getMinutes(), dateZhiding.getSeconds())
                        this.xhForm.cycleTask.isMaxCycle = data.cycleTask.maxCycleNum !== 0;
                        this.xhForm.cycleTask.maxCycleNum = data.cycleTask.maxCycleNum;
                        this.xhForm.cycleTask.cycleMustFinish = data.cycleTask.cycleMustFinish === '1';

                        this.xhTaskDetail = true;
                        this.isNewXhTask = false;
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.message
                        });
                    }
                }).catch((err) => {
                    console.log(err);
                    this.$message({
                        type: 'error',
                        message: '获取循环任务信息失败'
                    });
                });
            }
        },

        // 保存普通任务
        savePtTask () {
            this.$refs['ptForm'].validate((valid) => {
                if (valid) {

                    // 获取表单数据重新整理出接口参数
                    let obj = {};
                    obj.tableName = this.ptForm.tableName;
                    obj.comment = this.ptForm.comment;
                    if (!this.isNewPtTask) {
                        obj.tableId = this.ptForm.tableId;
                    }
                    obj.procTaskSys = [];
                    obj.procTaskEqp = [];

                    // 系统控制项
                    for (let item of this.ptForm.procTaskSys) {
                        if (item.procCode === '') {
                            return this.$message({
                                type: 'warning',
                                message: '请先选择系统控制项'
                            });
                        }
                        obj.procTaskSys.push({
                            procCode: item.procCode,
                            cmdNm: this.getCmdNm(item.procCode),
                            time: `1900-01-01 ${this.myUtils.addZero(item.time.getHours(), 2)}:${this.myUtils.addZero(item.time.getMinutes(), 2)}:${this.myUtils.addZero(item.time.getSeconds(), 2)}`,
                            timeDur: `1900-01-01 ${this.myUtils.addZero(item.timeDur.getHours(), 2)}:${this.myUtils.addZero(item.timeDur.getMinutes(), 2)}:${this.myUtils.addZero(item.timeDur.getSeconds(), 2)}`
                        })
                    }

                    // 设备控制项
                    for (let item of this.ptForm.procTaskEqp) {
                        if (item.equipSetValue.length === 0) {
                            return this.$message({
                                type: 'warning',
                                message: '请先选择设备控制项'
                            });
                        }
                        obj.procTaskEqp.push({
                            equipNo: item.equipSetValue[0],
                            setNo: item.equipSetValue[1],
                            equipSetNm: `${this.$refs[item.index].getCheckedNodes()[0].parent.label}-${this.$refs[item.index].getCheckedNodes()[0].label}`,
                            value: String(item.value),
                            time: `1900-01-01 ${this.myUtils.addZero(item.time.getHours(), 2)}:${this.myUtils.addZero(item.time.getMinutes(), 2)}:${this.myUtils.addZero(item.time.getSeconds(), 2)}`,
                            timeDur: `1900-01-01 ${this.myUtils.addZero(item.timeDur.getHours(), 2)}:${this.myUtils.addZero(item.timeDur.getMinutes(), 2)}:${this.myUtils.addZero(item.timeDur.getSeconds(), 2)}`
                        })
                    }

                    let apiName = this.isNewPtTask ? 'CreateCommonTask' : 'EditCommonTaskData';

                    this.$api[apiName](obj).then(res => {
                        if (res.data.code === 200) {
                            this.getRepository();
                            this.$message({
                                type: 'success',
                                message: this.isNewPtTask ? '新增成功' : '修改成功'
                            });
                            this.ptTaskDetail = false;
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message
                            });
                        }
                    }).catch(er => {
                        this.$message({
                            type: 'error',
                            message: this.isNewPtTask ? '新增失败' : '修改失败'
                        });
                    })
                }
            });
        },

        // 新增循环任务
        saveXhTask () {
            this.$refs['xhForm'].validate((valid) => {
                if (valid) {

                    // 获取表单数据重新整理出接口参数
                    let obj = {};
                    obj.tableName = this.xhForm.tableName;
                    obj.comment = this.xhForm.comment;
                    if (!this.isNewXhTask) {
                        obj.tableId = this.xhForm.tableId;
                    }
                    obj.cycleTask = {};
                    obj.cycleTaskContent = [];

                    let cycleTask = this.xhForm.cycleTask;
                    obj.cycleTask.beginTime = `1900-01-01 ${this.myUtils.addZero(cycleTask.intervalTime[0].getHours(), 2)}:${this.myUtils.addZero(cycleTask.intervalTime[0].getMinutes(), 2)}:${this.myUtils.addZero(cycleTask.intervalTime[0].getSeconds(), 2)}`;
                    obj.cycleTask.endTime = `1900-01-01 ${this.myUtils.addZero(cycleTask.intervalTime[1].getHours(), 2)}:${this.myUtils.addZero(cycleTask.intervalTime[1].getMinutes(), 2)}:${this.myUtils.addZero(cycleTask.intervalTime[1].getSeconds(), 2)}`;
                    obj.cycleTask.zhenDianDo = cycleTask.implement === '2' ? '1' : '0';
                    obj.cycleTask.zhidingDo = cycleTask.implement === '3' ? '1' : '0';
                    obj.cycleTask.cycleMustFinish = cycleTask.cycleMustFinish ? '1' : '0';
                    obj.cycleTask.zhidingTime = `1900-01-01 ${this.myUtils.addZero(cycleTask.zhidingTime.getHours(), 2)}:${this.myUtils.addZero(cycleTask.zhidingTime.getMinutes(), 2)}:${this.myUtils.addZero(cycleTask.zhidingTime.getSeconds(), 2)}`;
                    obj.cycleTask.maxCycleNum = Number(cycleTask.maxCycleNum);
                    obj.cycleTaskContent = JSON.parse(JSON.stringify(this.xhForm.cycleTaskContent));

                    // 判断是新增还是编辑
                    let apiName = this.isNewXhTask ? 'CreateCycleTask' : 'EditCycleyTaskData';

                    this.$api[apiName](obj).then(res => {
                        if (res.data.code === 200) {
                            this.getRepository();
                            this.$message({
                                type: 'success',
                                message: this.isNewXhTask ? '新增成功' : '修改成功'
                            });
                            this.xhTaskDetail = false;
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message
                            });
                        }
                    }).catch(er => {
                        this.$message({
                            type: 'error',
                            message: this.isNewXhTask ? '新增失败' : '修改失败'
                        });
                    })
                }
            });
        },

        // 删除任务
        delData (val, type) {
            let apiName = type === 'T' ? 'DelCommonData' : 'DelCycleData';
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.taskLoad = true;
                this.$api[apiName]({
                    tableId: val
                })
                    .then((res) => {
                        let code = res.data.code;
                        if (code === 200) {
                            this.$message({
                                type: 'success',
                                message: '删除成功'
                            });
                            this.getRepository();
                        } else {
                            this.$message({
                                type: 'error',
                                message: '删除失败'
                            });
                        }
                        this.taskLoad = false;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.taskLoad = false;
                    });
            })
                .catch((res) => {
                    this.taskLoad = false;
                });
        },

        // 关闭普通任务框回调事件
        closePtDetail () {
            this.isNewPtTask = true;
            this.$refs['ptForm'].resetFields();
            this.ptForm = {
                tableId: '',
                tableName: '',
                comment: '',
                procTaskSys: [
                    {
                        time: new Date(1900, 1, 1, new Date().getHours(), new Date().getMinutes(), new Date().getSeconds()),
                        timeDur: new Date(1900, 1, 1, 0, 0, 5),
                        procCode: '',
                        cmdNm: ''
                    }
                ],
                procTaskEqp: []
            }
        },

        // 关闭循环任务框回调事件
        closeXhDetail () {
            this.isNewXhTask = true;
            this.$refs['xhForm'].resetFields();
            this.xhForm = {
                tableId: '',
                tableName: '',
                comment: '',
                cycleTask: {
                    beginTime: '1900-01-01 00:00:00',
                    endTime: '1900-01-01 00:00:00',
                    intervalTime: [new Date(2020, 1, 1, 0, 0, 0), new Date(2020, 1, 1, 23, 59, 59)],
                    zhenDianDo: '0',
                    zhidingDo: '0',
                    implement: '1',
                    cycleMustFinish: '0',
                    zhidingTime: new Date(2020, 1, 1, 0, 0, 0),
                    isMaxCycle: false,
                    maxCycleNum: 0
                },
                cycleTaskContent: []
            };

            this.xhSysForm = {
                control: ''
            };
            this.xhEqpForm = {
                control: [],
                value: 0
            };
            this.xhTimeForm = {
                day: undefined,
                hour: undefined,
                min: undefined,
                second: undefined
            };
        }
    },
    watch: {
        xhForm: function (newVal) {
            this.$forceUpdate();
        }
    }
}
</script>
<style scoped lang="scss" src="./taskRepository.scss"></style>


// WEBPACK FOOTER //
// src/taskRepository.vue